export default __webpack_public_path__ + "static/media/MR.e21cdd69.svg";